export { getMapPage, getMapPageInfo, getMapPoints } from "./getMapPage";
